import { render, staticRenderFns } from "./CreateTellerForm.vue?vue&type=template&id=563510fc&scoped=true&"
import script from "./CreateTellerForm.vue?vue&type=script&lang=js&"
export * from "./CreateTellerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563510fc",
  null
  
)

export default component.exports